import { useEffect, useState } from "react";

export const CHIPS = [
  { key: "promotions", label: "Promotions" },
  { key: "newsletters", label: "Newsletters" },
  { key: "social", label: "Social" },
  { key: "receipts", label: "Receipts" },
  { key: "updates", label: "Updates" },
];

export const EMPTY_BASE = { category: null, q: "", after: "", before: "" };

export const hasBase = (b) => Boolean(b.category || b.q.trim() || b.after || b.before);

// Category chips, text search, and date range shared by the List and Summary views.
export default function FilterBar({ base, onChange }) {
  const [text, setText] = useState(base.q);

  // Keep the box in sync when filters are reset or the account changes.
  useEffect(() => setText(base.q), [base.q]);

  useEffect(() => {
    if (text === base.q) return undefined;
    const t = setTimeout(() => onChange({ ...base, q: text }), 400);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text]);

  const input = "h-8 border border-border bg-background px-2 text-xs font-mono";

  return (
    <div className="flex flex-wrap items-center gap-2 mb-4" data-testid="filter-bar">
      <button
        type="button"
        aria-pressed={!base.category}
        onClick={() => onChange({ ...base, category: null })}
        className={`h-8 px-3 text-xs font-mono border ${
          !base.category ? "bg-foreground text-background border-foreground" : "border-border hover:bg-secondary/40"
        }`}
        data-testid="chip-all"
      >
        All
      </button>
      {CHIPS.map((c) => {
        const on = base.category === c.key;
        return (
          <button
            key={c.key}
            type="button"
            aria-pressed={on}
            onClick={() => onChange({ ...base, category: on ? null : c.key })}
            className={`h-8 px-3 text-xs font-mono border ${
              on ? "bg-foreground text-background border-foreground" : "border-border hover:bg-secondary/40"
            }`}
            data-testid={`chip-${c.key}`}
          >
            {c.label}
          </button>
        );
      })}
      <input
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder="Search sender or subject"
        maxLength={100}
        className={`${input} w-52`}
        data-testid="search-input"
      />
      <label className="flex items-center gap-1 text-xs font-mono text-muted-foreground">
        From
        <input type="date" value={base.after} onChange={(e) => onChange({ ...base, after: e.target.value })} className={input} data-testid="date-from" />
      </label>
      <label className="flex items-center gap-1 text-xs font-mono text-muted-foreground">
        To
        <input type="date" value={base.before} onChange={(e) => onChange({ ...base, before: e.target.value })} className={input} data-testid="date-to" />
      </label>
      {hasBase(base) && (
        <button type="button" className="text-xs underline text-muted-foreground" onClick={() => onChange(EMPTY_BASE)} data-testid="clear-filters">
          Clear filters
        </button>
      )}
    </div>
  );
}
